import { useSetState } from '@domain-group/react-hooks'
import { FormField, LoadingBubbles } from '@domain-group/suit-theme'

import type { PublicationModel, PublicationEditionModel } from '@models/types'

import NoEditionsNotice from './components/NoEditionsNotice'
import PublicationEdition from './components/PublicationEdition'
import ToggleMoreEditionsButton from './components/ToggleMoreEditionsButton'

const EDITION_LIMIT = 4

const defaultState = {
  showAll: false,
}

interface PublicationEditionSelectorProps {
  callbacks: {
    selectPublicationEdition: (publicationEdition: PublicationEditionModel) => void,
  },
  loading: boolean,
  publicationEditions: PublicationEditionModel[],
  selectedPublication: PublicationModel,
  selectedPublicationEditionIds: number[],
}

const PublicationEditionSelector = (props: PublicationEditionSelectorProps) => {
  const {
    callbacks: {
      selectPublicationEdition,
    },
    loading = false,
    publicationEditions,
    selectedPublication,
    selectedPublicationEditionIds = [],
  } = props

  const [state, setState] = useSetState(defaultState)
  const { showAll } = state

  const filteredPublicationEditions = showAll ? publicationEditions : publicationEditions.slice(0, EDITION_LIMIT)
  const moreEditionsAvailable = publicationEditions.length > EDITION_LIMIT

  return (
    <FormField
      label="Select Editions"
      labelProps={{ flexShrink: 0, width: 'auto' }}
      labelRight={loading && (
        <LoadingBubbles color="blue" style={{ marginLeft: 'auto', width: 'auto' }} />
      )}
    >
      {!publicationEditions.length && (
        <NoEditionsNotice publication={selectedPublication} />
      )}

      {filteredPublicationEditions.map((publicationEdition) => {
        const selected = selectedPublicationEditionIds.includes(publicationEdition.id)

        return (
          <PublicationEdition
            callbacks={{
              selectPublicationEdition: () => selectPublicationEdition(publicationEdition),
            }}
            key={publicationEdition.id}
            publicationEdition={publicationEdition}
            selected={selected}
          />
        )
      })}

      {moreEditionsAvailable && (
        <ToggleMoreEditionsButton
          callbacks={{ toggleShowAll: () => setState({ showAll: !showAll }) }}
          showAll={showAll}
        />
      )}
    </FormField>
  )
}

export default PublicationEditionSelector
